import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../services/settings.service';
import { RegistroService } from '../services/registro.service';

declare function customInitFunctions(): void;

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styles: []
})
export class PagesComponent implements OnInit {
  anio: any;
  fecha: any;
  inicioSesion: any;
  finSesion: any;
  countdownTimer: any;
  minutes: any;
  remainingSeconds: any;

  datos:any;
cargo:string;
plantel:string;
Nombre:string;
Correo:string;
matriculaA: string;
vistamatricula=true;
  constructor(private settingsService: SettingsService, private router: Router,private registroService: RegistroService ) {
    this.restaurarSesion();
    this.datos=JSON.parse(localStorage.getItem('datos')!);
    this.cargo=this.datos.cargodb;
    this.plantel=this.datos.plantel;
    this.Nombre=this.datos.nom;
    this.Correo=this.datos.correop;
    this.matriculaA=this.datos.matriculaalumno;
  }

  ngOnInit(): void {
    // 🔒 Verificar token antes de inicializar la página
    const token = localStorage.getItem('token');
    if (!token) {
      // si no hay token, redirige al login
      this.router.navigate(['/login']);
      return;
    }

    // ✅ Si hay token, inicializa normalmente
    customInitFunctions();

    const hoy = new Date();
    this.fecha = hoy.toLocaleDateString();
    this.anio = hoy.getFullYear();
    this.inicioSesion = localStorage.getItem('inicioSesion');
    this.finSesion = localStorage.getItem('finSesion');

  }

  listaversiones() {
    this.router.navigate(['/dashboard/paginaversiones']);
  }

ngAfterViewInit(): void {
  this.secondPassed(); 
}


  secondPassed() {
    let seconds = 7200;
    const end = new Date().getTime() + seconds * 1000;

    const displayCounter = () => {
      const counter = Math.floor((end - new Date().getTime()) / 1000);
      const secondsRemaining = counter > 0 ? counter : 0;

      const countdownEl = document.getElementById('countdown');
      if (countdownEl) {
        countdownEl.innerHTML = ': ' + 
          Math.floor(secondsRemaining / 60) + ':' + 
          ('00' + Math.floor(secondsRemaining % 60)).slice(-2);
      }

      if (secondsRemaining === 0) {
        clearInterval(this.countdownTimer);
        console.log('⏰ ¡Tiempo Agotado!');
      }
    };

    // Ejecuta cada segundo
    this.countdownTimer = setInterval(displayCounter, 1000);
    displayCounter();
  }

restaurarSesion() {
  const datos = this.registroService.cargarSesionDesdeStorage();
  if (datos) {
    this.datos = datos;
    this.cargo = datos.cargodb;
    this.plantel = datos.plantel;
    this.Nombre = datos.nom;
    this.Correo = datos.correop;
    this.matriculaA = datos.matriculaalumno;
  } else {
    this.router.navigate(['/login']);
  }
}

}
